import { captureMessage, withScope } from '@sentry/browser'

/**
 * Which part of the email editor's start-up stalled (ORB-960): Unlayer's script and iframe never
 * started, or they started and the design never finished loading. Telling those apart is what the
 * first stuck editor couldn't do, because Unlayer runs in a cross-origin iframe nothing else sees into.
 */
export type EmailEditorStallStage = 'editor-not-started' | 'design-not-loaded'

/** Reports a stalled email editor with sizes and ids only, never the design or its copy. */
export function reportEmailEditorLoadFailure(
    stage: EmailEditorStallStage,
    details: { assetId?: string; hadDesign: boolean; designBytes: number; schemaVersion?: number; elapsedMs: number },
) {
    const tags = { area: 'email-editor', stage }

    withScope(scope => {
        // As in chatDiagnostics: drop inherited breadcrumbs and request data so the event carries only these fields.
        scope.addEventProcessor(event => ({
            ...event, breadcrumbs: [], extra: details, tags,
            request: undefined, user: undefined, contexts: undefined,
        }))
        captureMessage('Email editor did not load', {
            level: 'error', tags, extra: details,
            fingerprint: ['email-editor', stage],
        })
    })
}
